<form (ngSubmit)="onSubmit()" [formGroup]="formGroup">
  <div class="row">
    <div class="col-xs-12 col-md-12 form-group">
      <label for="bio" class="zaya-form-sub-header" i18n="label|the bio of a practitioner.@@labelTellUs">Tell us about yourself</label>
      <div class="d-flex flex-fill mb-4 zaya-form-help-text" i18n="label|Help text for the bio of a practitioner.@@labelApplicationTellUsHelpText">
        This is a great opportunity to tell us about your practice, your background, and why your work is important to you.
      </div>
      <textarea name="bio" id="bio" cols="30" rows="4" class="form-control" formControlName="bio" maxlength="700"></textarea>
      <div class="zaya-form-help-text text-right">{{ formGroup.value.bio ? formGroup.value.bio.length : 0 }} / 700</div>
      <span
        class="help-block"
        *ngIf="formGroup.get('bio').invalid && formGroup.get('bio').touched"
        i18n="error message|The message shown when a bio is not valid.@@errorBio">
          Please enter a valid bio.
      </span>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-12 col-md-12 form-group">
      <label for="approach" class="zaya-form-sub-header" i18n="label|the approach of a practitioner.@@labelPractitionerApproach">What can clients expect in your sessions?</label>
      <div class="d-flex flex-fill mb-4 zaya-form-help-text" i18n="label|Help text for the approach of a practitioner.@@labelApplicationApproachHelpText">
        Please describe your approach and what clients can expect during and after a session with you.
      </div>
      <textarea name="approach" id="approach" cols="30" rows="4" class="form-control" formControlName="approach" maxlength="700"></textarea>
      <div class="zaya-form-help-text text-right">{{ formGroup.value.approach ? formGroup.value.approach.length : 0 }} / 700</div>
      <span
        class="help-block"
        *ngIf="formGroup.get('approach').invalid && formGroup.get('approach').touched"
        i18n="error message|The message shown when a practitioner approach is not valid.@@errorApproach">
          Please enter a valid approach.
      </span>
    </div>
  </div>

  <hr>

  <div class="d-flex flex-fill justify-content-center">
    <button type="submit" class="btn btn-primary modal-btn mr-2" [disabled]="!formGroup.valid || isLoading">Submit</button>
    <button type="button" class="btn btn-secondary modal-btn" (click)="onDismiss()">Cancel</button>
  </div>
</form>
